import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Fab from '@material-ui/core/Fab';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';

import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import * as math from '_core/utils/math';
import { getVisitorPhotoSrc } from '_core/utils/getVisitorPhotoSrc';
import { Flex } from '_core/components/Flex';

import Rows from './Rows';


const renderValue = (props, column, rowData) => {
  const ValueComponent = column.ValueComponent;
  
  return <ValueComponent {...props} column={column} data={rowData} />
};


export default React.memo((props) => {
  const {
    langInfo,
    l,
    theme,
    classes,
    
    getCellStyles,
    columns,
    selected,
    setSelected,
    rowData,
    rowLevel,
    isRowExpanded,
    showRowInfo
  } = props;
  
  
  const [expand, setExpand] = React.useState([]);
  
  
  const expandRow = (rowData, value) => {
    if (value) {
      if (rowData.canExpand)
        setExpand([...expand, rowData.id]);
    } else {
      setExpand(expand.filter((id) => id !== rowData.id));
    }
  };
  
  
  var isExpanded = rowData && isRowExpanded && expand.indexOf(rowData.id) >= 0;
  
  return (
    <div>
      <div
        className={clsx(classes.row, { [classes.rowSelected]: rowData && selected === rowData.id })}
        onClick={() => rowData && setSelected(rowData.id)}
      >
        <div className={classes.rowColumns}>
          {columns.map((column, index) => (
            <div
              key={column.name}
              className={classes.cell}
              style={getCellStyles(theme, column, false)}
            >
              <div
                className={classes.cellInner}
                style={getCellStyles(theme, column, true)}
              >
                {!index ? (
                  <div
                    className={classes.treeContainer}
                    style={{ marginLeft: Math.min(theme.spacing((rowLevel - 1) * 2), theme.spacing(column.width) * 0.3) }}
                    onClick={() => rowData?.canExpand ? expandRow(rowData, !isExpanded) : null}
                  >
                    <div className={classes.treeLine}>
                      {rowData?.level === 0 ? (
                        <>
                          <div className={classes.treeLineRootArrow}>
                            <ArrowForwardIosIcon className={classes.treeLineArrowIcon} />
                          </div>
                        </>
                      ) : (
                        <>
                          <div className={classes.treeLineTop} />
                          <div className={classes.treeLineBottom} />
                          
                          <div className={classes.treeLineArrow}>
                            <ArrowForwardIosIcon className={classes.treeLineArrowIcon} />
                          </div>
                        </>
                      )}
                      
                      {rowData?.canExpand ? (
                        <div className={classes.expandBtn}>
                          {isExpanded ? (
                            <RemoveIcon className={classes.expandIcon} />
                          ) : (
                            <AddIcon className={classes.expandIcon} />
                          )}
                        </div>
                      ) : null}
                    </div>
                  </div>
                ) : null}
                
                {index === 1 ? (
                  rowData ? (
                    <Avatar
                      src={rowData.photo && getVisitorPhotoSrc(rowData.photo, 'md')}
                      onClick={() => showRowInfo(rowData)}
                    />
                  ) : (
                    <Skeleton
                      animation="wave"
                      variant="circle"
                      className={classes.skeletonAvatar}
                    />
                  )
                ) : null}
                
                <div className={classes.value} onClick={() => showRowInfo(rowData)}>
                  {rowData ? (
                    <column.ValueComponent
                      {...props}
                      
                      column={column}
                      data={rowData}
                    />
                  ) : (
                    <Skeleton
                      animation="wave"
                      variant="rect"
                      className={classes.skeleton}
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      
      {rowData?.canExpand ? (
        <div className={classes.childrenContainer}>
          <div className={clsx(classes.children, { [classes.childrenExpanded]: isExpanded })}>
            <Rows
              {...props}
              
              parent={rowData.id}
              rowLevel={rowLevel + 1}
              isRowExpanded={isExpanded}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
});
